import { render } from "./Digging.vue?vue&type=template&id=33f705f0&scoped=true"
import script from "./Digging.vue?vue&type=script&lang=js"
export * from "./Digging.vue?vue&type=script&lang=js"

import "./Digging.vue?vue&type=style&index=0&id=33f705f0&scoped=true&lang=css"

import exportComponent from "/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33f705f0"]])

export default __exports__